import { useMutation, useQueryClient } from "@tanstack/react-query";
import { hubMutations } from "@surgia/api/src/queryStore/hub";
import { toast } from "sonner";

export const useDeletePurchaseRequestItem = (draftQueryParams?: {
  branchId: string;
  componentId: string;
  tenantId: string;
}) => {
  const queryClient = useQueryClient();
  
  return useMutation({
    ...hubMutations.purchaseRequest.mutations.deleteItem(),
    
    onSuccess: async () => {
      toast.success("Item removed successfully");
      if (draftQueryParams) {
        // Convert tenantId to number to match the cache
        const queryKey = ['purchaseRequest', 'draft', {
          ...draftQueryParams,
          tenantId: Number(draftQueryParams.tenantId)
        }];

        queryClient.invalidateQueries({
          queryKey: queryKey
        });
      }
      const tenantProductQueries = queryClient.getQueriesData({
        queryKey: ['shared', 'tenant-products']
      });
      const tenantProductsQueryParams = tenantProductQueries?.[0]?.[0]?.[2]??{};
         await queryClient.invalidateQueries({
        queryKey: ['shared', 'tenant-products',{
          ...tenantProductsQueryParams,
        }],
        exact: false
      });
    },
    onError: (error) => {
      console.error('Failed to delete purchase request item:', error);
      toast.error("Failed to remove item. Please try again.");
    }
  });
}; 